import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { useCountdown } from '@hooks/.';
import './Banner.scss';

// eslint-disable-next-line import/prefer-default-export
export const BannerSize = Object.freeze({
    Small: 'sm',
    Large: 'lg',
});

/**
 * @typedef {Object} SequentialBannerProps
 * @property {string} bannerColor
 * @property {string} fontColor
 * @property {string} bannerLabel
 * @property {boolean} hasTimer
 * @property {Date|null} sourceEndTime
 * @property {string} size
 * @property {boolean} isEmployeeCanBidAfterAllottedTime
 *
 * @param {SequentialBannerProps} props
 */
function Banner({
    bannerColor,
    fontColor,
    bannerLabel,
    hasTimer,
    sourceEndTime,
    size = BannerSize.Small,
    isEmployeeCanBidAfterAllottedTime,
}) {
    const { t } = useTranslation('shiftBidding');
    const timeLeftText = useCountdown(sourceEndTime);

    let bannerBackgroundColor = bannerColor;
    let bannerFontColor = fontColor;
    let bannerText = bannerLabel;
    if (sourceEndTime !== null) {
        bannerText = bannerLabel + (hasTimer ? timeLeftText : '');

        if (timeLeftText === '') {
            if (isEmployeeCanBidAfterAllottedTime) {
                bannerBackgroundColor = '#FFDFA6';
                bannerFontColor = '#66460D';
                bannerText = t('shiftBidding:employee.common.banner.priorityLost');
            } else {
                bannerBackgroundColor = 'rgb(250,227,227)';
                bannerFontColor = '#d32f2f';
                bannerText = t('shiftBidding:employee.common.banner.priorityLostCantBidAfter');
            }
        }
    }
    
    return (
        <div
            className={size === BannerSize.Small ? 'banner-container-sm' : 'banner-container-lg'}
            style={{ backgroundColor: bannerBackgroundColor }}
        >
            <Typography
                variant={size === BannerSize.Small ? 'body2' : 'h5'}
                className="text-sm-medium"
                style={{ color: bannerFontColor }}
            >
                {bannerText}
            </Typography>
        </div>
    );
}

export default Banner;
